var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1818 3.33332H15.5454H13.0909V0.83332C13.0909 0.37332 12.7252 0 12.2727 0H5.72728C5.27483 0 4.90911 0.37332 4.90911 0.83332V3.33332H2.45455H0.818171C0.365728 3.33332 0 3.70664 0 4.16664C0 4.62664 0.36569 5 0.818171 5H1.63634V17.5C1.63634 18.8783 2.73763 20 4.0909 20H13.9091C15.2624 20 16.3637 18.8783 16.3637 17.5V5H17.1818C17.6343 5 18 4.62668 18 4.16668C18 3.70668 17.6343 3.33332 17.1818 3.33332ZM6.54545 1.66668H11.4546V3.33336H6.54545V1.66668ZM14.7273 17.5C14.7273 17.9592 14.3607 18.3333 13.9091 18.3333H4.0909C3.63926 18.3333 3.27272 17.9591 3.27272 17.5V5H5.72728H12.2728H14.7273V17.5H14.7273Z",
    fill: "#C6CCDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54562 6.66675C6.09318 6.66675 5.72745 7.04007 5.72745 7.50007V15.0001C5.72745 15.4601 6.09318 15.8334 6.54562 15.8334C6.99806 15.8334 7.36379 15.4601 7.36379 15.0001V7.50007C7.36379 7.04007 6.99806 6.66675 6.54562 6.66675Z",
    fill: "#C6CCDA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4547 6.66675C11.0023 6.66675 10.6366 7.04007 10.6366 7.50007V15.0001C10.6366 15.4601 11.0023 15.8334 11.4547 15.8334C11.9072 15.8334 12.2729 15.4601 12.2729 15.0001V7.50007C12.2729 7.04007 11.9072 6.66675 11.4547 6.66675Z",
    fill: "#C6CCDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.85e8e06e.svg";
export { ForwardRef as ReactComponent };